module.exports = __webpack_public_path__ + "img/h1-3.4a077fa6.jpg";